module.exports = __webpack_public_path__ + "img/oily.850f1b34.svg";